import $ from "cash-dom";
import validate from "./fieldValidator.js";
import { Validator } from './FormValidator';
import { sendGAEvent } from '../analytics';

export class ValidatorFactory {
  constructor(type : string, form : HTMLFormElement) {
    switch (type) {
      case "address":
        return new AddressValidator(form);
      case "people":
        return new PeopleValidator(form);
      case "agent-lead-form":
        return new RealEstateAgentLeadFormValidator(form);
      case "newsletter":
        return new NewsletterValidator(form);
      default:
        throw new Error("Validator not found");
    }
  }
}

class AddressValidator extends Validator {
  onSuccess() {
    $(this.form).removeClass('form-error');
    var input = $(this.form).find('input');
    var data = input.val() as string;
    var encoded_address = Validator.encode(data);

    if (input.hasClass('street-page')) {
      var searchType = input.data('default') != data ? 'user_input' : 'default';
      if (this.form.dataset.eventCategory === "street_page_interaction") {
        sendGAEvent({
          eventAction: this.form.dataset.eventAction,
          eventLabel: this.form.dataset.eventLabel,
          eventCategory: this.form.dataset.eventCategory
        });
    }
      window.location.href = $(this.form).data('flow') + 'address=' + encoded_address + '&search=' + searchType; 
      return;
    }

    window.location.href = $(this.form).data('flow') + 'address=' + encoded_address;
  }
  onError() {
    $(this.form).addClass('form-error');
  }
  onChangeEvent() {
  }
  getConstraints() {
    return {
      address: {
        presence: {
          allowEmpty: false,
          message: "Please enter an address"
        },
        notEmail: true
      }
    }
  }
}

class PeopleValidator extends Validator {
  onSuccess() {
    const $form = $(this.form);
    const fn = $form.find('[name=fn]').val();
    const ln = $form.find('[name=ln]').val();
    setLocalStorage(fn, ln);
    window.location.href = $form.data('flow');
  }
  onError() {
    $(this.form).addClass('form-error');
  }
  onChangeEvent() {
  }
  getConstraints() {
    return {
      fn: {
        presence: {
          allowEmpty: false,
          message: "Enter a first name"
        },
        notEmail: true,
        alphanumeric: true
      },
      ln: {
        presence: {
          allowEmpty: false,
          message: "Enter a last name"
        },
        notEmail: true,
        alphanumeric: true
      }
    }
  }
}

class NewsletterValidator extends Validator {
  constructor(form: HTMLFormElement) {
    super(form, 'change');
  }
  onSuccess() {
    const $form = $(this.form);
    const values = {
      lead: $form.find('[name=address]').val() as string,
      location: $form.data('location')
    }

    let block = $(this.form).siblings(".form-message");
    block.removeClass('has-text-danger').removeClass('has-text-success');
    block.text('');

    var data = 'newsletter=true&lead[email]=' + encodeURIComponent(values.lead)
    + '&lead[location]='+encodeURIComponent(values.location);

    fetch('https://www.neighborwho.com/api/v5/leads.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
      },
      body: data
    })
    .then((response) => {
      if (!response.ok) {
        throw Error(response.statusText);
      }
      
      return response.json()
    })
    .then(() => {
      block.addClass("has-text-success");
      block.text("Your email has been registered successfully");
    })
    .catch(() => {
      block.addClass("has-text-danger");
      block.text("Your request could not be processed. Please try again");
    });
  }
  onError() {
    $(this.form).addClass('form-error');
  }
  onChangeEvent() {
  }
  getConstraints() {
    return {
      address: {
        presence: {
          allowEmpty: false,
          message: "Please enter an email"
        },
        email: {
          message: "Please enter a valid email"
        }
      }
    }
  }
}

class RealEstateAgentLeadFormValidator extends Validator {
  onLoad() {
    this.triggerValidationEvent = null;
    super.onLoad();
  }
  onSuccess() {
    const forms = document.forms;
    for (let i = 0; i < forms.length; i++) {
      if(forms[i].name == "agent-lead") {
        const monocleAPI = $(forms[i]).attr('data-monocleAPI');
        const formValues = new FormData(forms[i]);
        const names = (<string>formValues.get('fullname')).split(' ').filter(Boolean);
        const firstName = names[0];
        const lastName = names.splice(1).join(' ');
        const phone = (formValues.get('phone') as string).replace(' ', '');
        const address = formValues.get('q');
        const radio = formValues.get('radio');
        if(firstName) {
          let formdata = {
            "email": '',
            "lead_type": radio,
            "name": `${firstName} ${lastName}`,
            "phone_number": phone,
            "report_address": address,
            "submit_timestamp": new Date().toUTCString()
          };

          fetch(monocleAPI, {
            method: 'POST',
            body: JSON.stringify(formdata),
          }).then(() => {
            $('#lead-form-modal').removeClass('is-hidden');
            $(".heading-text").hide();
            $(".property-widget__lead_form").hide();
            $(".toc").hide();
            $(".confirmation-text").show();
          }).catch((error) => {
            $('#lead-form-modal').removeClass('is-hidden');
          }); 
        }
      }        
    }
  }

  onError() {
  }
  onChangeEvent(hasError: boolean) {
  }
  getConstraints() {
    return {
      fullname: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a valid name"
        },
        fullName: {
          message: "^Please enter a valid name"
        }
      },
      phone: {
        presence: {
          allowEmpty: false,
          message: "^Please enter a valid phone number"
        },
        phoneUS: {
          message: "^Please enter a valid phone number"
        }
      }
    }
  }
}

/**
 * Custom Validators
 */

validate.validators.atLeastOneLetter = function (value) {
  if (!/[a-z]+/i.test(value)) {
    return "Alphabetic characters required";
  }
};

validate.validators.notEmail = function (value) {
  if (
    /^[ a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[ a-zA-Z0-9](?:[ a-zA-Z0-9-]{0,61}[ a-zA-Z0-9])?(?:\.[ a-zA-Z0-9](?:[ a-zA-Z0-9-]{0,61}[ a-zA-Z0-9])?)*$/.test(
      value
    )
  ) {
    return "Email addresses are not searchable here";
  }
};

validate.validators.fullName = function (value) {
  if (
    !/^([a-zA-Z]{2,}\s[a-zA-Z]{1,}'?-?[a-zA-Z]{2,}\s?([a-zA-Z]{1,})?)/.test(
      value
    )
  ) {
    return "Please specify a full name";
  }
};

validate.validators.phoneUS = function (value) {
  if (
    !/\(?\d{3}\)?-? *\d{3}-? *-?\d{4}/.test(
      value
    )
  ) {
    return "Please specify a valid phone number";
  }
};

validate.validators.alphanumeric = function(value) {
  if (!/^[\w.]+$/i.test(value)) {
    return "Letters, numbers, and underscores only please";
  }
}

validate.validators.noSpace = function(value) {
  if (!/^\s*$/.test(value)) {
    return "No empty or blank spaces allowed";
  }
}

var setLocalStorage = function (firstname, lastname) {
  try {
    localStorage.setItem("__amplify__searchData", JSON.stringify({
      "data":{
        "address": "",
        "fn": firstname,
        "ln": lastname,
        "city": "",
        "state": "",
        "hideName": false
      }
    }));
  } catch (error) {
    console.log(error);
  }
}
